<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formRequestNote">
        <div class="px-1 pb-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                routerLink="/request-note" [severity]="null" [width]="'6rem'"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [icon]="'pi pi-print'" [severity]="'contrast'"
                (onClick)="printPage()"></app-custom-button>
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileRequestNote [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                [disabled]="disabledButtons" (onClick)="deleteRequestNote()"></app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewRequestNote()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="noteContract.userNameCreate"
                [createDate]="noteContract.createDate" [userNameUpdate]="noteContract.userNameUpdate"
                [updateDate]="noteContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-7 p-top mt-1 pe-md-2">
              <div class="row d-flex align-items-end">
                <div class="col field-branch">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col field-enterprise">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                    [required]="true" [recovery]="true" (onChangeSelect)="getEnterprise($event, true)">
                  </app-custom-select>
                </div>
                <div class="col field-request-consecutive">
                  <app-custom-input-number formControlName="requestConsecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeRequestConsecutive()"></app-custom-input-number>
                </div>
                <div class="col field-type">
                  <app-custom-select formControlName="noteTypeId" [labelText]="'Tipo'" [list]="listNoteTypeFiltered"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeNoteType($event)"></app-custom-select>
                </div>
                <div class="col field-type-document">
                  <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo Doc.'"
                    [required]="true" [list]="listBussinessDocumentsTypes" [recovery]="true"
                    (onChangeSelect)="getBussinessDocumentsType($event, true)">
                  </app-custom-select>
                </div>
                <div class="col field-state d-flex align-items-end">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState"
                    [value]="requestNoteStateString"></app-custom-tag>
                  <div class="mx-1">
                    <label class="form-label"></label>
                    <div class="d-flex gap-1">
                      <app-custom-button [title]="titleStateRequestNote" [icon]="iconStateRequestNote"
                        [disabled]="disabledButtons" (onClick)="changeStateNote(true)"></app-custom-button>
                      <app-custom-button [title]="'Anular'" [icon]="'pi pi-ban'" [severity]="'warn'"
                        [disabled]="disabledButtons" (onClick)="annulRequestNote()"></app-custom-button>
                      <app-custom-button [title]="titleStateProcess" [icon]="iconStateProcess" [severity]="'success'"
                        [disabled]="!disabledActions || disabledButtons" (onClick)="changeStateNote(false)">
                      </app-custom-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col field-date">
                  <app-custom-datepicker formControlName="dateNote" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col field-level">
                  <app-custom-select formControlName="isLevelArticle" [labelText]="'Nivel'" [list]="listLevel"
                    [required]="true" (onChangeSelect)="changeLevel($event); changeValues()"></app-custom-select>
                </div>
                <div class="col field-concept">
                  <app-custom-select formControlName="conceptId" [labelText]="'Concepto'" [required]="true"
                    [list]="listConcepts" (onChangeSelect)="getConcept($event)"></app-custom-select>
                </div>
                <div class="col field-operation-type">
                  <app-custom-select formControlName="operationTypeDian" [required]="true"
                    [labelText]="'Tipo Operación'" [list]="copyListOperationsTypeDian"
                    (onChangeSelect)="changeValues()"></app-custom-select>
                </div>
                <div class="col field-affectation">
                  <app-custom-tag [label]="'Afectación'" [value]="this.noteContract.valueToPay == this.totalValueInvoice 
                    ? 'Vr.Total' : this.noteContract.valueToPay < this.totalValueInvoice ? 'Vr.Parcial (Manual)' : ''">
                  </app-custom-tag>
                </div>
              </div>
              <div class="row">
                <div class="col field-elaborate">
                  <app-custom-input-text formControlName="elaborate" [labelText]="'Elabora'"></app-custom-input-text>
                </div>
                <div class="col field-authorize">
                  <app-custom-input-text formControlName="authorize" [labelText]="'Autoriza'"></app-custom-input-text>
                </div>
                <div class="col field-revise">
                  <app-custom-input-text formControlName="revise" [labelText]="'Revisa'"></app-custom-input-text>
                </div>
                <div class="col field-approve">
                  <app-custom-input-text formControlName="approve" [labelText]="'Aprueba'"></app-custom-input-text>
                </div>
                @if (this.noteContract.consecutive != null) {
                <div class="col field-consecutive-note">
                  <app-custom-tag [label]="'Nro.Nota'" [value]="this.noteContract.consecutive != null ?
                      this.noteContract.consecutive.toString() : ''"></app-custom-tag>
                </div>
                }
              </div>
            </div>
            <div class="col-lg-5">
              <fieldset class="border mt-2">
                <div class="row px-2 p-top">
                  <div class="col field-invoice-consecutive">
                    <app-custom-input-number formControlName="invoiceConsecutive" [labelText]="'Factura'"
                      [required]="true" (onChangeNumber)="changeInvoice($event)"></app-custom-input-number>
                  </div>
                  <div class="col field-type-document-invoice">
                    <app-custom-select [labelText]="'Tipo Doc. Fra.'" [required]="true"
                      [formControl]="bussinessDocumentsTypeInvoiceForm" [list]="listBussinessDocumentsTypesInvoice"
                      (onChangeSelect)="getBussinessDocumentsTypeInvoice($event, true); changeValues()">
                    </app-custom-select>
                  </div>
                  <div class="col field-date-invoice">
                    <app-custom-input-text [disabled]="true" [labelText]="'Fecha'"
                      [value]="dateInvoice"></app-custom-input-text>
                  </div>
                  <div class="col field-client-invoice">
                    <app-custom-input-text [labelText]="'Cliente'" [value]="codeNameClient" [disabled]="true"
                      [inputClass]="stateClientId !== 1 ? 'text-danger':''"></app-custom-input-text>
                  </div>
                </div>
                <div class="row px-2 mb-2">
                  <div class="col field-cost-center-invoice">
                    <app-custom-input-text [disabled]="true" [labelText]="'C.Costos'" [value]="codeNameCostCenter"
                      [inputClass]="stateCostCenterId !== 1 ? 'text-danger':''"></app-custom-input-text>
                  </div>
                  <div class="col field-value-invoice">
                    <app-custom-input-decimal [disabled]="true" [labelText]="'Vr. Factura'"
                      [value]="totalValueInvoice"></app-custom-input-decimal>
                  </div>
                  <div class="col field-residue-invoice">
                    <app-custom-input-decimal [disabled]="true" [labelText]="'Saldo'"
                      [value]="residueValueInvoice"></app-custom-input-decimal>
                  </div>
                  <div class="col field-annul-button mt-1 d-flex align-items-end"
                    [hidden]="noteContract.noteTypeId == 2">
                    <app-custom-button [title]="'Anular Fra.'" [icon]="'pi pi-ban'" [severity]="'warn'"
                      [disabled]="disabledActions || buttonAnnuls" (onClick)="annulInvoiceByNote()">
                    </app-custom-button>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-lg-7">
              <div class="row align-items-end">
                <div class="col field-observations">
                  <app-custom-textarea formControlName="observationPrint" [labelText]="'Observación(Imprime)'"
                    [rows]="1" [autoResize]="false"></app-custom-textarea>
                </div>
                <div class="col field-observations">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false"></app-custom-textarea>
                </div>
                <div class="col field-save-button m-top">
                  <app-custom-button [title]="'Guardar Solicitud de nota'" [label]="'Guardar'" [severity]="'primary'"
                    [disabled]="disabledActions" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="container-style mt-2 pb-2">
    <app-request-note-detail [noteModel]="noteContract" [disabledActions]="disabledActions"
      [headerChanged]="headerChanged" (updateNote)="getUpdateNote($event)"
      (emitQuantityDetails)="onQuantityDetails($event)">
    </app-request-note-detail>
  </div>
  <form class="needs-validation mt-2 container-style" [formGroup]="formRequestNoteTotals">
    <div class="row d-flex justify-content-end pb-2 pt-1">
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="subtotalValue" [labelText]="'Subtotal'"></app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.Iva'"></app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="totalValue" [labelText]="'Total'"></app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="valueToPay" [labelText]="'Vr. A Pagar'"></app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="reteIvaValue" [labelText]="'Rte.Iva'"></app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="reteFuenteValue"
          [labelText]="invoiceSwSelfRetainer ? 'Auto.Rte.Fuente' : 'Rte.Fuente' "
          [ngClass]="invoiceSwSelfRetainer ? 'text-red' : ''">
        </app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-decimal formControlName="reteIcaValue"
          [labelText]="invoiceSwIcaSelfRetainer ? 'Auto.Rte.Ica' : 'Rte.Ica'"
          [ngClass]="invoiceSwIcaSelfRetainer ? 'text-red' : ''">
        </app-custom-input-decimal>
      </div>
      <div class="col field-totals">
        <app-custom-input-text [labelText]="'Moneda'" [ngClass]="codeCurrency != 'COP' ? 'text-danger' : ''"
          value={{codeCurrency}} [disabled]="true"></app-custom-input-text>
      </div>
    </div>
  </form>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
<!-- Imprimir Solicitud de Nota -->
<div id="container-print-note">
  <app-print-request-note *ngIf="printNoteFormat" id="print-note" [companyId]="companyId"
    [isLevelArticle]="noteContract.isLevelArticle" [requestNotePrintModel]="requestNotePrintModel" [focusText]="true"
    [editFormat]="false" [formatModel]="formatModel" (finishLoadingPrintNote)="finishLoading($event)">
  </app-print-request-note>
</div>